import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { CONTACT_EMAIL } from "@/lib/site";

const primaryLinks = [
  { label: "Accueil", to: "/" },
  { label: "Veille & Décryptages", to: "/veille" },
  { label: "Ressources", to: "/ressources" },
  { label: "La lettre BENZENATI", to: "/newsletter" },
  { label: "À propos", to: "/a-propos" },
];

const exploreLinks = [
  { label: "IA & Outils", to: "/ia-outils" },
  { label: "Réglementations", to: "/reglementations" },
];

const legalLinks = [
  { label: "Mentions légales", to: "/mentions-legales" },
  { label: "Politique de confidentialité", to: "/politique-de-confidentialite" },
];

const tid = (to) => (to === "/" ? "home" : to.slice(1));

export const Footer = () => (
  <footer className="border-t border-bz-line bg-bz-navy text-bz-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <span className="font-serif text-2xl tracking-[0.28em]">BENZENATI</span>
          <p className="mt-3 text-sm text-white/60">Atelier de veille et de décryptage</p>
          <p className="mt-6 flex items-center gap-2 text-sm text-white/70">
            <MapPin size={16} strokeWidth={1.4} />
            Bourgogne-Franche-Comté · France
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email-link"
            className="mt-3 flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-bz-amber"
          >
            <Mail size={16} strokeWidth={1.4} />
            {CONTACT_EMAIL}
          </a>
        </div>

        <div>
          <p className="bz-label text-white/50">Navigation</p>
          <ul className="mt-5 space-y-3">
            {primaryLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-nav-${tid(l.to)}`} className="text-sm text-white/70 transition-colors hover:text-bz-ivory">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="bz-label text-white/50">À explorer</p>
          <ul className="mt-5 space-y-3">
            {exploreLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-explore-${tid(l.to)}`} className="text-sm text-white/70 transition-colors hover:text-bz-ivory">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="bz-label text-white/50">Informations</p>
          <ul className="mt-5 space-y-3">
            {legalLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-legal-${tid(l.to)}`} className="text-sm text-white/70 transition-colors hover:text-bz-ivory">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-white/10 pt-8">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} BENZENATI · Atelier indépendant de veille, de décryptage et de mise en perspective.
        </p>
      </div>
    </div>
  </footer>
);
